import { takeEvery, fork, delay, put, all, call } from "redux-saga/effects"
import { initialPaymentAPI, getCouponAPI } from "./api"

import { initial_Payament_start, get_coupon_start } from "./constant"
import {
  InitialPaymentSuccess,
  InitialPaymentFailure,
  getCouponSuccess,
  getCouponFailure,
} from "./action"

function* PaymentGateway() {
  // Initial payment

  function* InitialPaymentAsync(action) {
    try {
      const response = yield call(initialPaymentAPI, action.payload)
      if (response.success === 200) {
        yield put(InitialPaymentSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(InitialPaymentFailure(error))
    }
  }

  function* InitialPayment() {
    yield takeEvery(initial_Payament_start, InitialPaymentAsync)
  }

  function* checkCouponAsync(action) {
    try {
      const response = yield call(getCouponAPI, action.payload)
      if (response.success === 200) {
        yield put(getCouponSuccess(response.data))
      } else {
        throw response
      }
    } catch (error) {
      yield put(getCouponFailure(error))
    }
  }

  function* checkCoupon() {
    yield takeEvery(get_coupon_start, checkCouponAsync)
  }

  yield all([fork(InitialPayment), fork(checkCoupon)])
}

export default PaymentGateway
